import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Pill } from 'ui-components/components/pill';

import Address from '../../../../components/address';
import PickupSettingsSchedule from './pickup-settings-schedule';
import { AddressPropType } from '../../../../prop-types/address';
import { PickupSettingsDayPropType } from '../../../../prop-types/pickup-settings-day';
import { useAreLocalDeliveryServicesAvailableForSeller } from '../../../../hooks/use-are-local-delivery-services-available-for-seller';

import messages from '../messages';
import style from '../style.module.less';
import EditButton from './edit-button';
import ShipFromActionsButton from './ship-from-actions-button';

const ShipFromRow = ({ shipFrom: { name, shipFromId, returnAddress, isDefault, pickupSettings, inventorySourceType, originAddress } }) => {
  const hasLocalDeliveryEnabled = useAreLocalDeliveryServicesAvailableForSeller();

  return (
    <>
      <div className={style['left-cell']}>
        <div>
          <EditButton label={name} shipFromId={shipFromId} />
        </div>
        {isDefault && <Pill className={style.pill} label={<FormattedMessage {...messages.shipFromDefault} />} theme='no-status' />}
      </div>
      <div className={style.cell}>{inventorySourceType}</div>
      <div className={style.cell}>
        <Address address={originAddress} addressWrapperClassName={style.address} />
      </div>
      <div className={style.cell}>
        <Address address={returnAddress} addressWrapperClassName={style.address} />
      </div>
      {hasLocalDeliveryEnabled && (
        <div className={style['pickup-settings-cell']}>
          <PickupSettingsSchedule pickupSettings={pickupSettings} shipFromId={shipFromId} />
        </div>
      )}
      <div className={style['right-cell']}>
        <ShipFromActionsButton shipFromId={shipFromId} />
      </div>
    </>
  );
};

ShipFromRow.propTypes = {
  shipFrom: PropTypes.shape({
    shipFromId: PropTypes.string,
    name: PropTypes.string,
    isDefault: PropTypes.bool,
    returnAddress: AddressPropType,
    pickupSettings: PropTypes.shape({
      days: PropTypes.arrayOf(PickupSettingsDayPropType),
    }),
    inventorySourceType: PropTypes.string,
    originAddress: AddressPropType,
  }).isRequired,
};

export default ShipFromRow;
